/* ============================================================
   Auto mega menu: reads REAL data from Meteor's own hidden
   mobile menu (already in the page) and builds tab panels.
   No manual product/brand typing needed.
   ============================================================ */

// Which top-level menus to build as tab-style panels (brand/category tabs)
const TAB_MENUS = ["Shop by Bike", "Helmets", "Spare Parts", "Accessories", "Riding Gears", "Luggage"];
// Which top-level menus to build as a simple flat link list
const SIMPLE_MENUS = ["Offers"];

function slugify(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

function cleanText(a) {
  const titleEl = a.querySelector(".Meteor-Drawer__ItemTitle");
  if (titleEl) {
    // first text node only (ignore the caret svg text)
    for (const node of titleEl.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        return node.textContent.trim();
      }
    }
  }
  return a.textContent.trim();
}

// Scrape a top-level Meteor mobile menu (by its aria-label) into {tabs:[{id,label,intro,products}]}
function scrapeTabsMenu(ariaLabel) {
  const menuRoot = document.querySelector(`.Meteor-MobileMenu[aria-label="${CSS.escape(ariaLabel)}"]`);
  if (!menuRoot) return null;

  const drawers = Array.from(menuRoot.querySelectorAll(".Meteor-Drawer"));
  if (drawers.length === 0) return null;

  // Map href -> drawer element, so we can find a sub-drawer for any link
  const drawerByHref = {};
  drawers.forEach((d) => {
    const headerLink = d.querySelector(".Meteor-Drawer__Header > a");
    if (headerLink) {
      drawerByHref[headerLink.getAttribute("href")] = d;
    }
  });

  // The first drawer in the menu is the root (top-level list: brands/categories)
  const rootDrawer = drawers[0];
  const rootItems = Array.from(
    rootDrawer.querySelectorAll(":scope > .Meteor-Drawer__ItemList > .Meteor-Drawer__Item")
  );

  const tabs = rootItems.map((item) => {
    const a = item.querySelector("a");
    const href = a.getAttribute("href");
    const label = cleanText(a);
    const subDrawer = drawerByHref[href];

    let products = [];
    if (subDrawer) {
      const subItems = Array.from(
        subDrawer.querySelectorAll(":scope > .Meteor-Drawer__ItemList > .Meteor-Drawer__Item")
      );
      products = subItems.map((si) => {
        const sa = si.querySelector("a");
        return {
          name: cleanText(sa),
          link: sa.getAttribute("href"),
          img: "",
        };
      });
    }

    return {
      id: slugify(label),
      label: label.toUpperCase(),
      intro: {
        img: "",
        title: `All ${label}`,
        desc: `${label} parts & accessories at Riders Junction.`,
        link: href,
      },
      products: products,
    };
  });

  return { type: "tabs", tabs };
}

// Scrape a flat top-level Meteor mobile menu into {links:[{name,link}]}
function scrapeSimpleMenu(ariaLabel) {
  const menuRoot = document.querySelector(`.Meteor-MobileMenu[aria-label="${CSS.escape(ariaLabel)}"]`);
  if (!menuRoot) return null;
  const items = menuRoot.querySelectorAll(".Meteor-Drawer__Item > a");
  const links = Array.from(items).map((a) => ({
    name: cleanText(a),
    link: a.getAttribute("href"),
  }));
  return { type: "simple", links };
}

function keyFor(label) {
  return slugify(label).replace(/-/g, "");
}

function buildAllMenuData() {
  const data = {};
  TAB_MENUS.forEach((label) => {
    const scraped = scrapeTabsMenu(label);
    if (scraped && scraped.tabs.length) data[keyFor(label)] = scraped;
  });
  SIMPLE_MENUS.forEach((label) => {
    const scraped = scrapeSimpleMenu(label);
    if (scraped && scraped.links.length) data[keyFor(label)] = scraped;
  });
  return data;
}

/* ============================================================
   Rendering (same as before, but data comes from scraping)
   ============================================================ */

function buildTabsMenu(menuKey, tabsData) {
  const stripEl = document.getElementById(`tabStrip-${menuKey}`);
  const contentsEl = document.getElementById(`tabContents-${menuKey}`);
  if (!stripEl || !contentsEl) return;
  stripEl.innerHTML = "";
  contentsEl.innerHTML = "";

  tabsData.tabs.forEach((tab, i) => {
    const btn = document.createElement("button");
    btn.className = "tab-btn" + (i === 0 ? " active" : "");
    btn.textContent = tab.label;
    btn.dataset.tab = tab.id;
    btn.addEventListener("click", () => activateTab(menuKey, tab.id));
    stripEl.appendChild(btn);

    const panel = document.createElement("div");
    panel.className = "tab-content" + (i === 0 ? " active" : "");
    panel.dataset.tab = tab.id;
    panel.innerHTML = `
      <div class="brand-intro">
        <h3>${tab.intro.title}</h3>
        <p>${tab.intro.desc}</p>
        <a href="${tab.intro.link}">VIEW PRODUCTS &rarr;</a>
      </div>
      <div class="product-grid">
        ${tab.products
          .slice(0, 30)
          .map(
            (p) => `
          <a class="product-item" href="${p.link}">
            <span class="thumb">IMG</span>
            <span class="name">${p.name}</span>
          </a>`
          )
          .join("")}
      </div>
    `;
    contentsEl.appendChild(panel);
  });
}

function activateTab(menuKey, tabId) {
  document.querySelectorAll(`#tabStrip-${menuKey} .tab-btn`).forEach((b) => {
    b.classList.toggle("active", b.dataset.tab === tabId);
  });
  document.querySelectorAll(`#tabContents-${menuKey} .tab-content`).forEach((c) => {
    c.classList.toggle("active", c.dataset.tab === tabId);
  });
}

function buildSimpleMenu(menuKey, simpleData) {
  const el = document.getElementById(`simpleList-${menuKey}`);
  if (!el) return;
  el.innerHTML = simpleData.links.map((l) => `<a href="${l.link}">${l.name}</a>`).join("");
}

function renderAllMenus(data) {
  Object.keys(data).forEach((key) => {
    if (data[key].type === "tabs") buildTabsMenu(key, data[key]);
    if (data[key].type === "simple") buildSimpleMenu(key, data[key]);
  });
}

/* ============================================================
   Nav open/close behaviour
   ============================================================ */

function setupNavInteractions() {
  const navItems = document.querySelectorAll(".header-nav .nav-item");
  const panels = document.querySelectorAll(".mega-panel");
  const headerNav = document.getElementById("headerNav");

  navItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      navItems.forEach((n) => n.classList.toggle("active", n === item));
      panels.forEach((p) => p.classList.toggle("open", p.dataset.panel === item.dataset.menu));
    });
  });
  if (headerNav) {
    headerNav.addEventListener("mouseleave", () => {
      panels.forEach((p) => p.classList.remove("open"));
    });
  }
}

/* ============================================================
   Init: wait for Meteor's own menu to actually be in the DOM
   before scraping (it may mount slightly after page load).
   ============================================================ */

function tryInit(attemptsLeft) {
  const data = buildAllMenuData();
  const gotAnyData = Object.keys(data).length > 0;

  if (gotAnyData) {
    renderAllMenus(data);
    setupNavInteractions();
    return;
  }

  if (attemptsLeft > 0) {
    setTimeout(() => tryInit(attemptsLeft - 1), 400);
  } else {
    console.warn("Custom mega menu: could not find Meteor mobile menu data to scrape.");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  tryInit(15); // retry up to ~6 seconds while Meteor mounts its menu
});